exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuActiveText": "#0c8aff",
	"menuColor": "#bfcbd9",
	"menuLightColor": "#1c7bf6",
	"menuColorActive": "#fff",
	"menuBackground": "#004e9b",
	"menuLightBackground": "#fff",
	"subMenuBackground": "#003f8a",
	"subMenuHover": "#0e61ec",
	"sideBarWidth": "200px",
	"logoTitleColor": "#fff",
	"logoLightTitleColor": "#001529"
};